import { STRINGS } from './constants';

export function getParameterByName(name: string, link: string) {
  const url = link ? link : window.location.href;
  name = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export const setCookie = (name: string, value: string, days: number): void => {
  const expires = new Date();
  expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/;Secure;SameSite=Lax`;
};

export const getCookie = (name: string): string => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    const raw = parts.pop()?.split(';').shift() || '';
    try {
      return decodeURIComponent(raw);
    } catch {
      return raw;
    }
  }
  return '';
};

export const deleteAllCookies = (): void => {
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });
};

export function LightenColor(color: string, percent: number) {
  const num = parseInt(color.replace("#", ""), 16),
    amt = Math.round(2.55 * percent),
    R = (num >> 16) + amt,
    B = (num >> 8 & 0x00FF) + amt,
    G = (num & 0x0000FF) + amt;
  return "#" + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 + (B < 255 ? B < 1 ? 0 : B : 255) * 0x100 + (G < 255 ? G < 1 ? 0 : G : 255)).toString(16).slice(1);
};

// export function rgba2hex(rgba: string) {
//   rgba = rgba.match(
//     /^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i
//   );
//   return rgba && rgba.length === 4
//     ? "#" +
//     ("0" + parseInt(rgba[1], 10).toString(16)).slice(-2) +
//     ("0" + parseInt(rgba[2], 10).toString(16)).slice(-2) +
//     ("0" + parseInt(rgba[3], 10).toString(16)).slice(-2)
//     : "";
// }

export const formatScheduledDate = (dateStr: string, separator = " ·"): string => {
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return "";

  const now = new Date();
  const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
  const isTomorrow =
    d.getFullYear() === tomorrow.getFullYear() &&
    d.getMonth() === tomorrow.getMonth() &&
    d.getDate() === tomorrow.getDate();

  const time = d.toLocaleTimeString("en-GB", { hour: "numeric", minute: "2-digit", hour12: true });
  if (isTomorrow) return `Tomorrow, ${time}`;

  const datePart = d
    .toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short", year: "numeric" })
    .replace(",", "");
  return `${datePart}${separator} ${time}`;
};

export const ID_STATUS_ENUM = {
  SKIPPED: 'SKIPPED',
  VALID: 'VALID',
  INVALID: 'INVALID',
  ID_UNRECOGNIZED: 'ID UNRECOGNIZED',
  SYSTEM_ERROR: 'SYSTEM ERROR',
};

//advance mega location fields name
export const POINT_OF_ENTRY: string = STRINGS.COMMON.POINT_OF_ENTRY;
export const PARKING_LOT: string = STRINGS.COMMON.PARKING_LOT;
export const DESTINATION: string = STRINGS.COMMON.DESTINATION;


// export const debounce = <T extends (...args: any[]) => any>(
//   func: T,
//   delay: number
// ): ((...args: Parameters<T>) => void) => {
//   let timeoutId: NodeJS.Timeout;
//   return (...args: Parameters<T>) => {
//     clearTimeout(timeoutId);
//     timeoutId = setTimeout(() => func(...args), delay);
//   };
// };

// export const throttle = <T extends (...args: any[]) => any>(
//   func: T,
//   limit: number
// ): ((...args: Parameters<T>) => void) => {
//   let inThrottle: boolean;
//   return (...args: Parameters<T>) => {
//     if (!inThrottle) {
//       func(...args);
//       inThrottle = true;
//       setTimeout(() => (inThrottle = false), limit);
//     }
//   };
// };

// export const generateId = (): string => {
//   return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
// };
